import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';

import { NotificationComponent } from '../components/notification.component';
import { Notification } from '../models/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private snackbar = inject(MatSnackBar);

  open(data: Notification): MatSnackBarRef<NotificationComponent> {
    return this.snackbar.openFromComponent(NotificationComponent, {
      data,
      duration: data.duration === null || data.actionBtn ? undefined : (data.duration ?? 3000),
      panelClass: 'eiq-notification',
      horizontalPosition: 'right',
      verticalPosition: 'bottom'
    });
  }
}
